import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GateronSmoothie = () => (
  <ArticleWrapper articleId="gateron_smoothie">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Gateron Smoothie</h1>
      {/* Add your Gateron Smoothie article content here */}
      <p>This is a placeholder article for the Gateron Smoothie switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default GateronSmoothie;
